var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcSnx32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3531_6625)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3531_6625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9983 31.9965C24.8339 31.9965 31.9965 24.8339 31.9965 15.9983C31.9965 7.16267 24.8339 0 15.9983 0C7.16267 0 0 7.16267 0 15.9983C0 24.8339 7.16267 31.9965 15.9983 31.9965Z",
    fill: "url(#paint0_linear_3531_6625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7287 12.0207C10.6008 11.862 10.4068 11.7738 10.1996 11.7738H5.92659C5.89131 11.7738 5.86044 11.7606 5.83398 11.7385C5.81194 11.7165 5.79871 11.69 5.79871 11.6591V8.77963C5.79871 8.74876 5.81194 8.7223 5.83398 8.70026C5.86044 8.6738 5.89131 8.66057 5.92659 8.66498H10.4421C11.5798 8.66498 12.5631 9.1324 13.3922 10.0628L14.4902 11.4034L12.3515 14.0095L10.7287 12.0207ZM18.622 10.0496C19.4466 9.12799 20.4344 8.66498 21.5853 8.66498H26.0876C26.1185 8.66057 26.1493 8.6738 26.1714 8.69144C26.1934 8.71348 26.2022 8.74435 26.1978 8.77963V11.6591C26.1978 11.69 26.189 11.7165 26.1714 11.7385C26.1493 11.765 26.1185 11.7782 26.0876 11.7738H21.8146C21.6118 11.7694 21.4177 11.862 21.2855 12.0207L18.137 15.8527L21.2987 19.7112C21.4266 19.8567 21.6162 19.9449 21.8102 19.9405H26.0832C26.114 19.9361 26.1493 19.9537 26.167 19.9758C26.1846 20.0022 26.1978 20.0375 26.1934 20.0684V22.9479C26.1934 22.9788 26.1846 23.0052 26.167 23.0273C26.1449 23.0537 26.114 23.0669 26.0832 23.0625H21.5853C20.4344 23.0625 19.4554 22.5951 18.6352 21.6647L16.0159 18.4677L13.3966 21.6647C12.572 22.5951 11.5842 23.0625 10.4333 23.0625H5.92659C5.89572 23.0669 5.86044 23.0493 5.8428 23.0273C5.82075 23.0008 5.81193 22.9655 5.81634 22.9347V20.0551C5.81634 20.0243 5.82516 19.9978 5.8428 19.9758C5.86485 19.9493 5.89572 19.9361 5.92659 19.9405H10.1996C10.4024 19.9405 10.5964 19.8479 10.7287 19.6936L13.8199 15.9189L18.622 10.0496Z",
    fill: "#00D1FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3531_6625",
    x1: 16.0005,
    y1: -0.000092603,
    x2: 16.0005,
    y2: 8.46647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#090220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#170659"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3531_6625"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3531_6625"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSnx32);
export default __webpack_public_path__ + "static/media/ic_snx_32.7f9c6ab6113dc0f7ba4651e8407b8ded.svg";
export { ForwardRef as ReactComponent };